import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ShieldCheck} from 'lucide-react';
import {api} from '../api';
import {Modal, PrimaryButton} from '../design';

export const BetaNoticeCopy = () => (
  <div className="pd-beta-copy">
    <p>
      <strong>The deployment operator can access content stored in this workspace</strong> when needed to
      operate the service, investigate failures, recover data, or provide support.
    </p>
    <p>
      Workflows you approve may send selected data to third-party services configured for this deployment.
      PursuitDeck can prepare and fill application material, but it does not make a final external submission
      automatically.
    </p>
    <p>
      Retention and deletion details, along with the configured operator contact, are available on the{' '}
      <a href="/privacy">privacy page</a>.
    </p>
  </div>
);

export const BetaNotice = ({opened}: {opened: boolean}) => {
  const queryClient = useQueryClient();
  const accept = useMutation({
    mutationFn: api.acceptBetaNotice,
    onSuccess: (payload) => queryClient.setQueryData(['bootstrap'], payload),
  });

  return (
    <Modal
      opened={opened}
      onClose={() => undefined}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      size="lg"
      centered
      title={
        <span className="pd-modal-title">
          <ShieldCheck size={22} aria-hidden="true" />
          Before you use this workspace
        </span>
      }
    >
      <BetaNoticeCopy />
      {accept.isError ? (
        <p className="pd-form-error" role="alert">
          {accept.error instanceof Error ? accept.error.message : 'The acknowledgment could not be saved.'}
        </p>
      ) : null}
      <PrimaryButton fullWidth loading={accept.isPending} onClick={() => accept.mutate()}>
        I understand — open my workspace
      </PrimaryButton>
    </Modal>
  );
};
